module.exports = __webpack_public_path__ + "static/media/banner-lupa.bad13ff0.jpg";